import { SpecialEventsGrid } from '@/components/special-events/grid';

const SpecialEvents = () => <SpecialEventsGrid />;

export default SpecialEvents;
